import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/electricity-cost-calculator',
  component: () => import('../../routes/ElectricityCostCalculator.svelte'),
  card: {
    id: 'electricity-cost-calculator',
    title: 'Electricity Cost Calculator',
    description: 'Estimate the cost of running an electrical device based on watts, hours, and your electricity rate.',
    icon: 'bolt',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/electricity-cost-calculator',
    category: 'Life & Budget',
  },
  seo: {
    title: 'Electricity Cost Calculator – Estimate Appliance Energy Costs',
    description: 'Free electricity cost calculator. Enter the wattage of any appliance, how many hours you use it, and your cost per kWh to see daily, monthly, and annual energy costs.',
  },
};

export default meta;
